import request from '@/utils/request';
import {
  endpoints,
  pmnFunctionEndpoint,
} from '@/constants/urls';

const pmnFunctions = () => request({
  url: endpoints.PMN_FUNCTIONS,
  method: 'GET',
});

const pmnFunction = (code) => request({
  url: pmnFunctionEndpoint(code),
  method: 'GET',
});

const PmnFunctionsService = {
  pmnFunctions,
  pmnFunction,
};

export default PmnFunctionsService;
